import { Toaster as Sonner } from "sonner";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import GenericSender from "./pages/GenericSender.tsx";
import NotFound from "./pages/NotFound";
import Login from "@/pages/Login.tsx";
import { SidebarShell } from "@/components/SidebarShell.tsx";
import { AuthorizedGuard } from "@/components/AuthorizedGuard.tsx";
import SearchDestination from "@/pages/SearchDestination.tsx";
import EventLog from "@/pages/EventLog.tsx";
import Dashboard from "@/pages/Dashboard.tsx";
import Replies from "@/pages/Replies.tsx";

const App = () => (
  <>
    <Sonner />
    <BrowserRouter>
      <SidebarShell>
        <Routes>
          <Route element={<AuthorizedGuard />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/generic-sender" element={<GenericSender />} />
            <Route path="/event-log" element={<EventLog />} />
            <Route path="/replies" element={<Replies />} />
            <Route
              path="/search-destinations"
              element={<SearchDestination />}
            />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </SidebarShell>
    </BrowserRouter>
  </>
);

export default App;
